import { AffiliateLink } from "./types/affiliate_link"

export const countryCodeFilter = (link: AffiliateLink) => !!link.countryCode;

export const streamRentBuyFilter = (link: AffiliateLink) => !!link.option && Array.prototype.constructor('Stream', 'Rent', 'Buy').includes(link.option);



// WEBPACK FOOTER //
// ./js/utils/AffiliateLinkHelper.ts